import React from 'react';

import money from '@billogram/money';

import FoundationTextbox from './FoundationTextbox';
import FoundationTextboxTextSymbol from './FoundationTextboxTextSymbol';

import type {
    FoundationMoneyTextboxProps,
    FoundationTextboxChangeEvent,
} from './types';


function noop(): void {}

function FoundationMoneyTextbox({
    onChange = noop,
    type = 'float',
    value = money.create(),
    ...props
}: FoundationMoneyTextboxProps, ref: React.Ref<HTMLInputElement>): React.ReactElement {
    function handleChange(evt: FoundationTextboxChangeEvent): void {
        onChange({
            rawValue: {
                currency: value.currency,
                value: evt.rawValue,
            },
            value: {
                currency: value.currency,
                value: evt.value as number,
            },
        });
    }

    return (
        <FoundationTextbox
            { ...props }
            ref={ ref }
            onChange={ handleChange }
            value={ value.value !== null && value.value !== void 0 ? value.value.toString() : '' }
            symbol={ (<FoundationTextboxTextSymbol text={ value.currency } />) }
            type={ type } />
    );
}

export default React.forwardRef(FoundationMoneyTextbox);
